<tt-page *ngIf="!!menu">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_info">
            <tt-input ttLabel="prodgrp_id" [ttModel]="menu.prodgrp_id" ttReadonly></tt-input>
            <tt-input ttLabel="prodgrp_name" [ttModel]="menu.prodgrp_name" ttReadonly></tt-input>
            <tt-input ttLabel="prodgrp2_id" [ttModel]="menu.prodgrp2_id" ttReadonly></tt-input>
            <tt-input ttLabel="prodgrp2_name" [ttModel]="menu.prodgrp2_name" ttReadonly></tt-input>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_functions">
            <tt-button-goto [ttText]="'prodgrp2menu_edit'" [ttGoto]="'prodgrp2'" [ttGotoParms]="{ prodgrp_id: menu.prodgrp_id, prodgrp2_id: menu.prodgrp2_id }"></tt-button-goto>
        </tt-card>
    </div>

    <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0 height-full">
    <tt-card class="col-xs-12 col-md-4 p-5">
        <tt-input class="col-xs-12 sp-0" tt-label="prodgrp_id" tt-model="vm.model.menu.prodgrp_id" tt-change="vm.model.menu.prodgrp_id = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="prodgrp_name" tt-model="vm.model.menu.prodgrp_name" tt-change="vm.model.menu.prodgrp_name = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="prodgrp2_id" tt-model="vm.model.menu.prodgrp2_id" tt-change="vm.model.menu.prodgrp2_id = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="prodgrp2_name" tt-model="vm.model.menu.prodgrp2_name" tt-change="vm.model.menu.prodgrp2_name = $value" tt-readonly="true"></tt-input>
        <tt-button-goto class="col-xs-12 sp-0" tt-text="prodgrp2menu_edit" tt-goto="prodgrp2" tt-goto-parms="{ prodgrp_id: vm.model.menu.prodgrp_id, prodgrp2_id: vm.model.menu.prodgrp2_id }" tt-text-align="left"></tt-button-goto>
    </tt-card>

    <tt-grid ng-if="vm.model.gridReady" class="col-xs-12 p-5 flex-1" tt-options="vm.grid"></tt-grid>
</tt-page>-->
